import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";
import {
  ClientRatesRequest,
  ClientRatesResponse,
  IFavouriteContactsResponse,
  NumberRegisteredRequest,
  NumberRegisteredResponse,
  PhoneNumbersResponse,
} from "../../types";

export const api = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Calls", "PhoneNumbers", "Contacts", "Balance"],
  keepUnusedDataFor: 300, // Keep data in cache for 5 minutes (300 seconds)
  refetchOnMountOrArgChange: 60, // Refetch if data is older than 60 seconds when mounting
  endpoints: (builder) => ({
    getPhoneNumbers: builder.query<PhoneNumbersResponse, void>({
      query: () => "/phoneNumbers",
      providesTags: ["PhoneNumbers"],
    }),
    getCallLogs: builder.query<any, void>({
      query: () => "/calls/recent-calls",
      providesTags: ["Calls"],
    }),
    getFavouriteContacts: builder.query<IFavouriteContactsResponse, void>({
      query: () => "/contacts/favourite",
      providesTags: ["Contacts"],
    }),
    isNumberRegistered: builder.mutation<
      NumberRegisteredResponse,
      NumberRegisteredRequest
    >({
      query: (body) => ({
        url: "/calls/is-number-registered",
        method: "POST",
        body,
      }),
    }),
    verifyForNumber: builder.mutation<{}, {}>({
      query: (body) => ({
        url: "/auth/send/email/verLink",
        method: "POST",
        body,
      }),
    }),
    verifyDirectEmailOtp: builder.mutation<{}, { otp: string }>({
      query: (body) => ({
        url: "/auth/signup2/verify/directEmailOtp",
        method: "POST",
        body,
      }),
    }),

    getClientRates: builder.mutation<ClientRatesResponse, ClientRatesRequest>({
      query: (body) => ({
        url: "/calls/clientRates",
        method: "POST",
        body,
      }),
    }),
    getBalanceInfo: builder.query<any, void>({
      query: () => "/settings/dialpad",
      providesTags: ["Balance"],
    }),
  }),
});

export const {
  useGetPhoneNumbersQuery,
  useGetCallLogsQuery,
  useGetFavouriteContactsQuery,
  useIsNumberRegisteredMutation,
  useVerifyForNumberMutation,
  useVerifyDirectEmailOtpMutation,
  useGetClientRatesMutation,
  useGetBalanceInfoQuery,
} = api;
